import { createContext, useContext } from 'react';
import { getNode } from './treeUtils';

const ScriptContext = createContext(null);
export default ScriptContext;

export function useScript() {
  return useContext(ScriptContext);
}

// Returns the JSON node at the given path.
export function useScriptNode(path) {
  const { compId, comps } = useScript();
  return getNode(comps[compId].script, path);
}

// Returns a function that applies an updater to the script.
export function useUpdateScript() {
  const { compId, comps, setComps } = useScript();
  return (updater) => {
    const newComps = JSON.parse(JSON.stringify(comps));
    updater(newComps[compId].script);
    setComps(newComps);
  };
}
